import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { PageSectionWrapper } from "../../components/PageSectionWrapper";
import { VariantTitle } from "../../components/VariantTitle";
import { Container } from "./Container";
import { ComponentRegistry } from "../../components/ComponentRegistry";
export const CustomContentContainer = ({ headerText, subtitle, variant, content, containerType, mobileContainerType, 
// siteStatus,
// isStatic,
// parsedFunctions,
formattedSectionStyles, id, isStatic = false, }) => {
    return (_jsxs(PageSectionWrapper, { variant: variant, isNested: true, parsedClasses: "rounded-xl ", sectionId: id, children: [headerText && (_jsx(VariantTitle, { title: headerText, subtitle: subtitle, parsedClasses: formattedSectionStyles === null || formattedSectionStyles === void 0 ? void 0 : formattedSectionStyles.headerStyling, isNested: true, sectionId: id })), _jsx(Container, { containerType: containerType, mobileContainerType: mobileContainerType, sectionId: id, children: _jsx(ComponentRegistry, { content: content, isStatic: isStatic }) })] }));
};
